import React from "react";
import "./Footer.css";

const Footer = () => {
  const navItems = [
    { name: "Карты", url: "https://yandex.ru/maps" },
    { name: "Погода", url: "https://yandex.ru/pogoda" },
    { name: "Расписание", url: "https://rasp.yandex.ru" },
    { name: "Календарь", url: "https://calendar.yandex.ru" },
    { name: "Путешествия", url: "https://travel.yandex.ru" },
  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <nav>
        <ul className="footer__navs">
          {navItems.map((item, index) => (
            <li key={index} className="footer__nav-item">
              <a
                className="footer__nav-link"
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      </nav>
      <p className="footer__copyright">&copy; {currentYear}. Ступников Арсений</p>
    </footer>
  );
};

export default Footer;

